"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@ellucian/react-design-system/core");
var _toolkit = require("@reduxjs/toolkit");
var _userenderscount = _interopRequireDefault(require("@hedtech/userenderscount"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _formSlice = require("../redux/slices/formSlice");
var _getDateString = _interopRequireDefault(require("../../utilities/getDateString"));
var _excluded = ["intl"],
  _excluded2 = ["name", "formatFromStore", "formatToStore", "helperText", "onBlur", "onFocus", "required", "requiredErrorTextId", "validate"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// Expects YYYY-mm-dd
var getLocalDateFromString = function getLocalDateFromString(dateStr) {
  try {
    var dateObj = new Date();
    dateObj.setHours(0, 0, 0, 0);
    var parts = dateStr.split('-').map(function (p) {
      return parseInt(p);
    });
    if (parts.length === 3 && parts.every(function (p) {
      return !isNaN(p);
    })) {
      dateObj.setFullYear(parts[0]);
      dateObj.setMonth(parts[1] - 1);
      dateObj.setDate(parts[2]);
    } else {
      throw new Error('Unexpected number of parts of string');
    }
    return dateObj;
  } catch (err) {
    console.error("Unable to parse date string ".concat(dateStr));
    console.error(err);
    return new Date(dateStr);
  }
};
var FormDateRangePicker = function FormDateRangePicker(_ref) {
  var intl = _ref.intl,
    props = _objectWithoutProperties(_ref, _excluded);
  var nameProp = props.name,
    _props$formatFromStor = props.formatFromStore,
    formatFromStore = _props$formatFromStor === void 0 ? function (values) {
      var value = [null, null];
      if (values) {
        value = values.split(',').map(function (it) {
          var newValue = null;
          if (it) {
            if (typeof it === 'string') {
              newValue = getLocalDateFromString(it);
            } else {
              newValue = new Date(it);
            }
          }
          return newValue;
        });
      }
      return value;
    } : _props$formatFromStor,
    _props$formatToStore = props.formatToStore,
    formatToStore = _props$formatToStore === void 0 ? function (values) {
      var newValues = values.map(function (it) {
        if (!it) {
          return null;
        }
        return (0, _getDateString["default"])(it);
      }).join(',');
      return newValues;
    } : _props$formatToStore,
    _props$helperText = props.helperText,
    helperTextProp = _props$helperText === void 0 ? null : _props$helperText,
    onBlurProp = props.onBlur,
    onFocusProp = props.onFocus,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$requiredErrorT = props.requiredErrorTextId,
    requiredErrorTextId = _props$requiredErrorT === void 0 ? 'validateRequired' : _props$requiredErrorT,
    validateProp = props.validate,
    rest = _objectWithoutProperties(props, _excluded2);
  (0, _userenderscount["default"])("FormDateRangePicker( ".concat(nameProp, " )"));
  var formatMessage = intl.formatMessage;
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectAlwaysShowError = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.meta, "forceShowErrors.".concat((0, _lodash.head)((0, _lodash.toPath)(nameProp))));
    }, function (value) {
      return !!value;
    });
  }, [nameProp]);
  var selectValue = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.values, (0, _lodash.toPath)(nameProp));
    }, function (value) {
      return formatFromStore(value);
    });
  }, [nameProp, formatFromStore]);
  var selectError = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.errors, (0, _lodash.toPath)(nameProp));
    }, _lodash.identity);
  }, [nameProp]);
  var selectTouched = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.touched, (0, _lodash.toPath)(nameProp));
    }, _lodash.identity);
  }, [nameProp]);
  var value = (0, _reactRedux.useSelector)(selectValue);
  var error = (0, _reactRedux.useSelector)(selectError);
  var touched = (0, _reactRedux.useSelector)(selectTouched);
  var alwaysShowError = (0, _reactRedux.useSelector)(selectAlwaysShowError);
  var validate = (0, _react.useMemo)(function () {
    var isRequired = function isRequired(value) {
      if (!required) {
        return undefined;
      }
      if (!value) {
        return formatMessage({
          id: requiredErrorTextId
        });
      }
      if (value.length !== 2 || !value[0] || !value[1]) {
        return formatMessage({
          id: requiredErrorTextId
        });
      }
    };
    var composeValidators = function composeValidators() {
      var fns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return function (value, allValues, meta) {
        var validators = [isRequired].concat(_toConsumableArray(fns));
        var error;
        for (var x = 0; x < validators.length; x++) {
          error = validators[x](value, allValues, meta);
          if (error) {
            break;
          }
        }
        return error;
      };
    };
    var validatorsArray = validateProp;
    if (validateProp && typeof validateProp === 'function') {
      validatorsArray = [validateProp];
    }
    return composeValidators(validatorsArray);
  }, [formatMessage, required, validateProp, requiredErrorTextId]);
  (0, _react.useEffect)(function () {
    dispatch((0, _formSlice.validateField)({
      name: nameProp,
      validate: validate,
      value: value
    }));
  }, [dispatch, nameProp, validate, value]);
  var onChange = (0, _react.useCallback)(function (value) {
    dispatch((0, _formSlice.setValue)({
      name: nameProp,
      value: formatToStore(value)
    }));
  }, [dispatch, formatToStore, nameProp]);
  var onBlur = (0, _react.useCallback)(function () {
    (0, _reactRedux.batch)(function () {
      dispatch((0, _formSlice.setTouched)({
        name: nameProp,
        value: true
      }));
      dispatch((0, _formSlice.setFocused)({
        name: nameProp,
        value: false
      }));
    });
    onBlurProp && onBlurProp();
  }, [dispatch, nameProp, onBlurProp]);
  var onFocus = (0, _react.useCallback)(function () {
    dispatch((0, _formSlice.setFocused)({
      name: nameProp,
      value: true
    }));
    onFocusProp && onFocusProp();
  }, [dispatch, nameProp, onFocusProp]);
  // Leaving the following code along with the method commented out as these props may return in a future release from deprecation and the onBlur prop is not currently behaving as intended. 
  // Previously the Path DateRangePicker is a composite component of two inputs. Each input emit their own focus and blur events.
  // The following code waits a little bit to call form.blur to make sure the user isn't just switching between the inputs.
  // If the user is, the new focus event will come in and interupt the onBlur.
  /*const timeout = useRef(null);
  const refocus = useRef(false);
  const onBlurWrapper = useCallback(() => {
      refocus.current = false;
      timeout.current = setTimeout(() => {
          clearTimeout(timeout.current);
          if (!refocus.current) {
              onBlur();
          }
      }, 100);
  }, [onBlur]);
  const onFocusWrapper = useCallback(() => {
      refocus.current = true;
      onFocus();
  }, [onFocus]);*/
  var hasError = false;
  var helperText = helperTextProp;
  if (error && (touched || alwaysShowError)) {
    hasError = true;
    helperText = error;
  }
  return /*#__PURE__*/_react["default"].createElement(_core.DateRangePicker, _extends({
    error: hasError,
    helperText: helperText,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    required: required,
    value: value
  }, rest));
};
FormDateRangePicker.propTypes = {
  intl: _propTypes["default"].object,
  formatFromStore: _propTypes["default"].func,
  formatToStore: _propTypes["default"].func,
  helperText: _propTypes["default"].node,
  name: _propTypes["default"].string.isRequired,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  requiredErrorTextId: _propTypes["default"].string,
  validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)])
};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(FormDateRangePicker);